import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function SiteFooter() {
  const { t } = useTranslation();
  return (
    <footer className="w-full border-t border-border/60 py-6 text-center text-xs text-muted-foreground">
      <nav aria-label={t("common.footerAria")} className="mx-auto flex max-w-md flex-wrap items-center justify-center gap-x-4 gap-y-2 px-4">
        <Link to="/terms" className="hover:text-foreground">{t("common.terms")}</Link>
        <span aria-hidden>·</span>
        <Link to="/privacy" className="hover:text-foreground">{t("common.privacy")}</Link>
      </nav>
      <p className="mt-3 px-4">© {new Date().getFullYear()} Lerna AI — {t("common.footerCopyright")}</p>
    </footer>
  );
}
